import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Send } from "lucide-react";

export const TwilioTestSmsCard = ({ cfg, onChanged }) => {
  const [to, setTo] = useState("");
  const [body, setBody] = useState("Test SMS depuis PAG Business Manager ✓");
  const [testing, setTesting] = useState(false);

  const send = async () => {
    if (!to.startsWith("+")) { toast.error("Numéro au format E.164 attendu (+33…)"); return; }
    setTesting(true);
    try {
      const { data } = await api.post("/admin/twilio/test-sms", { to, body });
      if (data.ok) toast.success(`SMS envoyé — SID ${data.provider_sid?.slice(0, 12)}… (suivez la livraison dans le journal)`);
      else toast.error(`Échec : ${data.reason}`);
      await onChanged?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setTesting(false); }
  };

  return (
    <div className="p-5 bg-white border border-[#DEE2E6]" data-testid="tw-test-card">
      <div className="font-display font-bold text-lg mb-3 flex items-center gap-2">
        <Send className="h-5 w-5 text-[#059669]" />Envoyer un SMS de test
      </div>
      <div className="grid gap-3">
        <div>
          <Label className="text-[10px] uppercase tracking-wider">Destinataire (+E.164)</Label>
          <Input value={to} onChange={(e) => setTo(e.target.value)} placeholder="+33612345678" data-testid="tw-test-to" />
        </div>
        <div>
          <Label className="text-[10px] uppercase tracking-wider">Message</Label>
          <Input value={body} onChange={(e) => setBody(e.target.value)} maxLength={160} data-testid="tw-test-body" />
        </div>
      </div>
      <div className="mt-3 flex items-center gap-2">
        <Button onClick={send} disabled={testing || !cfg?.enabled} data-testid="tw-send-test" className="bg-[#059669] text-white">
          <Send className="h-4 w-4 mr-1" />{testing ? "Envoi…" : "Envoyer test"}
        </Button>
        {!cfg?.enabled && <span className="text-xs text-[#F59E0B]" data-testid="tw-test-disabled">Configurez Twilio d'abord</span>}
      </div>
    </div>
  );
};
